import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { VehicleService } from '../../../../shared/sdk';
import { VehicleServiceGridComponent } from '../vehicle-service-grid/vehicle-service-grid.component';

@Component({
  selector: 'app-vehicle-service-list',
  templateUrl: './vehicle-service-list.component.html',
  styleUrls: ['./vehicle-service-list.component.scss'],
})
export class VehicleServiceListComponent implements OnInit {
  @Output() mySelected: EventEmitter<VehicleService> = new EventEmitter<VehicleService>();

  @ViewChild(VehicleServiceGridComponent, { static: true }) grid: VehicleServiceGridComponent;

  constructor() {}

  ngOnInit() {}

  grid_onSelected(keys: VehicleService) {
    this.mySelected.emit(keys);
  }

  repaint() {
    this.grid.repaint();
  }
}
